module.exports = __webpack_public_path__ + "static/blog75-137ac460b69ba2c77d34b80bb2733979.png";